import React from 'react';
import classes from './style.module.css'
import { Col } from 'react-bootstrap';

import ProfileMenu from "../UI/ProfileMenu"
import ModeToggleButton from "../UI/ToggleButtonSingle"
import InfoText from "../UI/InfoText"
import MatchSelectionPanel from "../SelectionPanel"
import ExportData from "../ExportData"
import { SET_SELECTION_STATE, SET_SOCCER_LEAGUES_STATE, SET_SOCCER_MATCHES_STATE } from "../../redux/actions"
import { connect } from "react-redux"
import {HEADER_CONTROLS, MODE_LEAGUES, MODE_MATCHES} from "../../constants/Constants"
import {logInfo} from '../../util/log/logger'
import { getPreviousNthDayStr, passDateToStringWithFormat } from '../../util/date/date-utils';

const Header = props => {

   const modeToggleButtonLabel = props.selectionState.mode === MODE_LEAGUES ? HEADER_CONTROLS.TOGGLE_MODE_BUTTON.label1 : HEADER_CONTROLS.TOGGLE_MODE_BUTTON.label0 

   const modeToggleButtonClickedHandler = () => {
        logInfo(`modeToggleButtonClickedHandler | clicked. current mode: ${props.selectionState.mode}`)
        if(props.selectionState.mode === MODE_LEAGUES) {
            props.setSoccerLeaguesState([])
        }else {
            props.setSoccerMatchesState([])
        }
        const selectionState = {...props.selectionState}
        selectionState.mode = props.selectionState.mode === MODE_LEAGUES ? MODE_MATCHES : MODE_LEAGUES
        selectionState.selectionDate = getPreviousNthDayStr(0)
        props.setSelectionState(selectionState)
   }

   const updateTier = (val) => {
       console.log("in upudate tier" + val);
       props.tierChangeHandler(val);
    
}


   let matchSelectionPanel = props.selectionState.mode === MODE_MATCHES ? <MatchSelectionPanel updateTier={updateTier}/> : null

   return (
       <>
            <Col className={classes.HeaderLeft} xs={4}>
                <InfoText placeholder={passDateToStringWithFormat(props.selectionState.selectionDate, "YYYY/MM/DD")} />  
                <ExportData label={HEADER_CONTROLS.EXPORT_DATA_BUTTON.label} mode={props.selectionState.mode} 
                                selectionDate={props.selectionState.selectionDate} 
                                home={props.selectionState.home}
                                away={props.selectionState.away}/>
            </Col>
            <Col className={classes.HeaderRight} xs={8}>
                {matchSelectionPanel}
                <ModeToggleButton label={modeToggleButtonLabel} clicked={modeToggleButtonClickedHandler}/>
                <ProfileMenu logoutClicked={props.logoutClicked} />
            </Col>
       </>
   );
}

const mapStateToProps = (state, ownProps) => {
    return {
        selectionState: state.selectionState,
        ...ownProps
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setSoccerLeaguesState: payload =>
            dispatch({ type: SET_SOCCER_LEAGUES_STATE, payload: payload }),
        setSelectionState: payload =>
            dispatch({ type: SET_SELECTION_STATE, payload: payload }),
        setSoccerMatchesState: payload =>
            dispatch({ type: SET_SOCCER_MATCHES_STATE, payload: payload }),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Header);
